module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "inclusivity.b5c58135.webp" + "?" + Date.now();